"use client";
import { PageType } from "@/types/types";
import { useEffect } from "react";
import EventBus, { Events } from "../event-bus";

interface Props {
	queryID: string;
	pageType: PageType;
}

/**
 * This component is responsible for dispatching the productsViewed event.
 * Can be used on product listing pages, search results pages, etc.
 *
 * @param props.products The products to dispatch the event for
 * @returns null as it doesn't render anything
 */
export const QueryIdSetter = ({ queryID, pageType }: Props) => {
	useEffect(() => {
		const allowedPageTypes = ["product", "category", "search"];

		// if there isn't a queryID and we are on an allowed page type, don't dispatch the event
		// use what might already be set as the queryID
		if (queryID === "" && allowedPageTypes.includes(pageType)) {
			return;
		}

		let queryIdToSet = queryID;

		// if isn't an allowed page type, clear the queryID
		if (!allowedPageTypes.includes(pageType)) {
			queryIdToSet = "";
		}

		// dispatch the event
		EventBus.dispatch(Events.queryIdSet, {
			queryID: queryIdToSet,
		});
	}, [queryID, pageType]);

	return null;
};
